import React from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { FormField } from "component/shared/form-fields";
import { styles } from "./style";

interface OwnProps {
	/** Omitted when the card holds a single field, as with v9 Page Head. */
	title?: string;
	description?: string;
	value: string;
	onChange: (value: string) => void;
	/** Draws the rule that separates this subsection from the one above it. */
	divider?: boolean;
}

interface Props extends OwnProps, WithStyles<typeof styles> {}

// One "Code" subsection of the Display page's custom code card (CSS panels 1 and 2): a bold title,
// its description, and an editable textarea labelled "Code".
const Component: React.FC<Props> = ({ classes = {}, title, description, value, onChange, divider }) => (
	<>
		{divider && <Mui.Divider className={classes.divider} />}
		{title && <Mui.Typography className={classes.labelTitle}>{title}</Mui.Typography>}
		{description && <Mui.Typography className={classes.labelDescription}>{description}</Mui.Typography>}
		<FormField
			label="Code"
			value={value}
			onChange={(event) => onChange(event.target.value)}
			multiline
			rows={9}
			spellCheck={false}
		/>
	</>
);

export const CodeField = withStyles(Component, styles);
